import { render, staticRenderFns } from "./OnTopic.vue?vue&type=template&id=ebdaf26e&"
import script from "./OnTopic.vue?vue&type=script&lang=js&"
export * from "./OnTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports